import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DeviceVerificationState } from 'types/deviceVerification';

const initialState: DeviceVerificationState = {
  username: null,
  transactionId: null,
  maskedEmail: null,
  maskedPhone: null,
  isLoading: false,
  error: null,
  otpSent: false,
  isVerifying: false,
};

const deviceVerificationSlice = createSlice({
  name: 'deviceVerification',
  initialState,
  reducers: {
    setDeviceVerificationData: (state, action: PayloadAction<{
      username: string;
      transactionId: string;
      maskedEmail: string;
      maskedPhone: string;
    }>) => {
      state.username = action.payload.username;
      state.transactionId = action.payload.transactionId;
      state.maskedEmail = action.payload.maskedEmail;
      state.maskedPhone = action.payload.maskedPhone;
      state.otpSent = true;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setVerifying: (state, action: PayloadAction<boolean>) => {
      state.isVerifying = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
      state.isVerifying = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    resetVerification: (state) => {
      return initialState;
    },
  },
});

export const {
  setDeviceVerificationData,
  setLoading,
  setVerifying,
  setError,
  clearError,
  resetVerification,
} = deviceVerificationSlice.actions;

export default deviceVerificationSlice.reducer; 